<template>
  <header :class="$style.authHeader">
    <LogoIcon />
  </header>
</template>

<script setup>

import { LogoIcon } from '@/shared/constants/newDesignIcons';
</script>

<style lang="scss" module>
.authHeader {
  z-index: $z-index-modal-overflow-1;
  position: relative;
  display: flex;
  justify-content: center;
  gap: 50px;
  align-items: center;
  width: 100%;
  padding: 18px;
  outline: 1px solid $border-default;
  background-color: $background-surface;
}
</style>
